import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { TTProtection } from "../TTProtection";
import { ttProtectionUrls } from "../../../URL/ApplicationUrls";
import { namedQueryKeyWithId } from "../../../ReactQuery/namedQueryKeyWithId";

export const useFetchTTProtection = (ttProtectionId: number | string | undefined) => {
  return useQuery<TTProtection, Error>({
    queryKey: namedQueryKeyWithId("ttProtections", ttProtectionId),
    queryFn: () => fetchTTProtection(ttProtectionId),
    onError: () => {
      toast.error(
        `An error occurred when retrieving the TT Protection with the P-Nr. ${ttProtectionId}`
      );
    },
  });
};

const fetchTTProtection = async (ttProtectionId: number | string | undefined) => {
  const { data: ttProtection } = await axios.get<TTProtection>(
    ttProtectionUrls.apiDetailsFor(ttProtectionId)
  );

  return ttProtection;
};
